import { ERROR_MODALS } from "../../containers/payroll-error-modal/constants/payroll-errors";

export type PayrollFileState = {
    loadingFile: boolean;
    file: string;
    error: {
        messages: string[];
        typeModal: ERROR_MODALS;
        isOpen: boolean;
    };
    totalAmountOfSalary: number;
    totalNumberOfWorkers: number;
    totalPayrollOfWorkers: [];
    fileName: string;
    filePath: string;
    initFileName: string;
};

export const payrollFileDefaultState: PayrollFileState = {
    loadingFile: false,
    file: null,
    error: {
        messages: null,
        typeModal: null,
        isOpen: false,
    },
    totalAmountOfSalary: 0,
    totalNumberOfWorkers: 0,
    totalPayrollOfWorkers: null,
    fileName: null,
    filePath: null,
    initFileName: null,
};
